module.exports = __webpack_public_path__ + "static/arthur-lung-particles-b7f0fe2ae77f59864314e45ba31dc840.png";